import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { usePropertyPanel } from '../PropertyPanelContext';
import RichEditorModal from '../../common/RichEditorModal';

const DualBannerProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  const [editingImageIndex, setEditingImageIndex] = useState(null);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  
  // 컨텍스트에서 필요한 값과 함수들 가져오기
  const context = usePropertyPanel() || {};
  const {
    devicePropertyTab = 'pc',
    getDevicePropertyValue = (source, field, defaultValue) => defaultValue,
    handleImageUpload = async () => null
  } = context;
  
  // 컴포넌트 속성 변경 핸들러
  const updateComponentProps = (property, value) => {
    if (!selectedComponent) return;
    
    const existingProps = JSON.parse(JSON.stringify(selectedComponent.componentProps || {}));
    existingProps[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        componentProps: existingProps
      }
    }));
  };
  
  // 이미지 배열 가져오기
  const images = selectedComponent?.componentProps?.images || [];
  
  // 이미지 추가
  const addImage = () => {
    const newImage = {
      imageUrl: '',
      linkUrl: '',
      linkTarget: '_self',
      altText: '',
      textContent: ''
    };
    updateComponentProps('images', [...images, newImage]);
  };
  
  // 이미지 삭제
  const removeImage = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    updateComponentProps('images', newImages);
  };
  
  // 이미지 속성 업데이트
  const updateImage = (index, field, value) => {
    const newImages = [...images];
    newImages[index] = { ...newImages[index], [field]: value };
    updateComponentProps('images', newImages);
  };
  
  // 이미지 업로드 핸들러
  const handleImageUploadForIndex = async (index, e) => {
    const imageUrl = await handleImageUpload(e);
    if (imageUrl) {
      updateImage(index, 'imageUrl', imageUrl);
    }
  };
  
  if (!selectedComponent) return null;
  
  return (
    <>
      {/* 배너 이미지 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <i className="fas fa-image"></i> 배너 이미지 설정
        </div>
        <div className="property-control">
          <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
            2개 이상의 이미지를 업로드하면 랜덤하게 2개가 선택됩니다
          </p>
          {images.map((image, index) => (
            <div key={index} style={{ 
              border: '1px solid #ddd', 
              padding: '10px', 
              marginBottom: '10px',
              borderRadius: '4px',
              backgroundColor: '#f8f8f8'
            }}>
              <div className="property-control">
                <label>이미지 URL</label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <input
                    type="text"
                    placeholder="이미지 URL"
                    value={image.imageUrl}
                    onChange={(e) => updateImage(index, 'imageUrl', e.target.value)}
                    style={{ flex: 1 }}
                  />
                  <label className="upload-button" style={{ 
                    padding: '8px 12px', 
                    backgroundColor: '#4a90e2', 
                    color: 'white', 
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}>
                    업로드
                    <input 
                      type="file" 
                      accept="image/*" 
                      onChange={(e) => handleImageUploadForIndex(index, e)} 
                      style={{ display: 'none' }}
                    />
                  </label>
                </div>
              </div>
              <div className="property-control">
                <label>링크 URL</label>
                <input
                  type="text"
                  placeholder="https://example.com"
                  value={image.linkUrl}
                  onChange={(e) => updateImage(index, 'linkUrl', e.target.value)}
                />
              </div>
              <div className="property-control">
                <label>링크 타겟</label>
                <select
                  value={image.linkTarget}
                  onChange={(e) => updateImage(index, 'linkTarget', e.target.value)}
                >
                  <option value="_self">현재 창</option>
                  <option value="_blank">새 창</option>
                </select>
              </div>
             
              <div className="property-control">
                <label>텍스트 콘텐츠</label>
                <button
                  onClick={() => {
                    setEditingImageIndex(index);
                    setIsEditorOpen(true);
                  }}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    backgroundColor: '#4a90e2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  에디터로 편집하기
                </button>
                {image.textContent && (
                  <div style={{
                    marginTop: '8px',
                    padding: '8px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px',
                    fontSize: '12px',
                    color: '#666',
                    maxHeight: '60px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {image.textContent.replace(/<[^>]*>/g, '').substring(0, 50)}...
                  </div>
                )}
              </div>
              <button 
                onClick={() => removeImage(index)}
                style={{
                  width: '100%',
                  padding: '8px',
                  backgroundColor: '#ff4d4f',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  marginTop: '10px'
                }}
              >
                <i className="fas fa-trash"></i> 삭제
              </button>
            </div>
          ))}
          <button 
            onClick={addImage}
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#f0f0f0',
              border: '1px dashed #d9d9d9',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '10px'
            }}
          >
            <i className="fas fa-plus"></i> 이미지 추가
          </button>
        </div>
      </div>
      
      {/* 오버레이 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <i className="fas fa-palette"></i> 오버레이 설정
        </div>
        <div className="property-control">
          <label>오버레이 색상</label>
          <div className="color-picker-container">
            <input 
              type="color" 
              value={selectedComponent.componentProps?.overlayColor || '#000000'} 
              onChange={(e) => updateComponentProps('overlayColor', e.target.value)}
            />
          </div>
        </div>
        <div className="property-control">
          <label>오버레이 불투명도</label>
          <input 
            type="range" 
            min="0" 
            max="1" 
            step="0.1" 
            value={selectedComponent.componentProps?.overlayOpacity || 0.3} 
            onChange={(e) => updateComponentProps('overlayOpacity', parseFloat(e.target.value))}
          />
          <span>{((selectedComponent.componentProps?.overlayOpacity || 0.3) * 100).toFixed(0)}%</span>
        </div>
        <div className="property-control">
          <label>텍스트 색상</label>
          <div className="color-picker-container">
            <input 
              type="color" 
              value={selectedComponent.componentProps?.textColor || '#ffffff'} 
              onChange={(e) => updateComponentProps('textColor', e.target.value)}
            />
          </div>
        </div>
      </div>
      
      {/* 크기 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <i className="fas fa-ruler"></i> 크기 설정
        </div>
        <div className="property-control">
          <label>높이 (px)</label>
          <input 
            type="number" 
            min="200" 
            max="800" 
            value={selectedComponent.componentProps?.height || 400} 
            onChange={(e) => updateComponentProps('height', parseInt(e.target.value))}
          />
        </div>
        <div className="property-control">
          <label>이미지 간격 (px)</label>
          <input 
            type="number" 
            min="0" 
            max="50" 
            value={selectedComponent.componentProps?.gap || 10} 
            onChange={(e) => updateComponentProps('gap', parseInt(e.target.value))}
          />
        </div>
      </div>
      
      {/* 리치 에디터 모달 */}
      {isEditorOpen && editingImageIndex !== null && (
        <RichEditorModal
          isOpen={isEditorOpen}
          content={images[editingImageIndex]?.textContent || ''}
          initialContent={images[editingImageIndex]?.textContent || ''}
          onSave={(content) => {
            updateImage(editingImageIndex, 'textContent', content);
            setIsEditorOpen(false);
            setEditingImageIndex(null);
          }}
          onClose={() => {
            setIsEditorOpen(false);
            setEditingImageIndex(null);
          }}
        />
      )}
    </>
  );
};

export default DualBannerProperties;